import Vue from 'vue';
import Vuex from 'vuex';
import Security from './modules/Security';
import UserPreference from './modules/UserPreference';

Vue.use(Vuex);

const isStrictMode = process.env.NODE_ENV !== 'production' &&
  process.env.VUE_APP_KEYCLOAK_ENABLED !== 'true';

export const store = new Vuex.Store({
  strict: isStrictMode,
  modules: {
    'security': Security,
    'userPreference': UserPreference
  }
});
